export const STORAGE_VIDEO_DEVICE_ID_KEY = 'videoDeviceId';
